<template>
  <section
    ref="section7"
    :class="[(Object.keys(validationErrors).length > 0 ? 'has-errors' : ''), 'mx-auto flex h-full flex-col']"
  >
    <v-add-listing-head
      :routes="routes"
      :step="7"
    ></v-add-listing-head>
    <main
      class="flex h-full flex-col items-center justify-between overflow-y-scroll px-4 py-8 md:px-12"
    >
      <figure class="flex max-w-lg flex-col gap-11 lg:w-full">
        <figure class="flex gap-3">
          <div>
            <v-icon icon="home-arrows-circle" size="8"></v-icon>
          </div>
          <div class="flex flex-col justify-center">
            <div class="mb-3 text-heading-3-desktop">
              Nepremičnina se lahko uporabi za
            </div>
            <div class="text-body-regular text-black-40">
              Izberete lahko samo eno možnost.
            </div>
          </div>
        </figure>
        <form method="POST" :action="routes.submitForm" id="select-usage-type">
          <v-csrf-token></v-csrf-token>
          <figure class="ml-auto mr-auto flex w-full max-w-lg flex-col gap-8">
            <ul class="flex flex-col gap-8">
              <li class="w-full">
                <div :class="['radio group flex items-center', (validationErrors.nutzungsart ? 'has-errors' : '')]">
                  <input
                    id="bivanje"
                    type="radio"
                    value="wohnen"
                    name="nutzungsart"
                    class="hidden"
                    v-model="usageType"
                  />
                  <label for="bivanje" class="w-full text-body-medium-button">
                    <div class="label flex flex-col gap-[10px]">
                      <div class="flex items-center gap-3">
                        <v-icon icon="bed-single"></v-icon>
                        <div class="text-heading-4-medium">Bivanje</div>
                      </div>
                      <small class="text-body-regular text-black-40"
                        >Nepremičnina se lahko uporablja samo za bivanje za
                        določen ali nedoločen čas. Podrobnosti navedite v opisu
                        nepremičnine.</small
                      >
                    </div>
                    <div class="icon">
                      <v-icon icon="radio-unchecked" class="unchecked"></v-icon>
                      <v-icon icon="radio-checked" class="checked"></v-icon>
                    </div>
                  </label>
                </div>
              </li>
              <li class="w-full">
                <div :class="['radio group flex items-center', (validationErrors.nutzungsart ? 'has-errors' : '')]">
                  <input
                    id="poslovniProstor"
                    type="radio"
                    value="gewerbe"
                    name="nutzungsart"
                    class="hidden"
                    v-model="usageType"
                  />
                  <label
                    for="poslovniProstor"
                    class="w-full text-body-medium-button"
                  >
                    <div class="label flex flex-col gap-[10px]">
                      <div class="flex items-center gap-3">
                        <v-icon icon="business"></v-icon>
                        <div class="text-heading-4-medium">Poslovni prostor</div>
                      </div>
                      <small class="text-body-regular text-black-40"
                        >Nepremičnina se lahko uporablja za poslovne namene za
                        določen ali nedoločen čas. Podrobnosti navedite v opisu
                        nepremičnine.</small
                      >
                    </div>
                    <div class="icon">
                      <v-icon icon="radio-unchecked" class="unchecked"></v-icon>
                      <v-icon icon="radio-checked" class="checked"></v-icon>
                    </div>
                  </label>
                </div>
              </li>
              <li class="w-full">
                <div :class="['radio group flex items-center', (validationErrors.nutzungsart ? 'has-errors' : '')]">
                  <input
                    id="kratkorocnaOddaja"
                    type="radio"
                    value="waz"
                    name="nutzungsart"
                    class="hidden"
                    v-model="usageType"
                  />
                  <label
                    for="kratkorocnaOddaja"
                    class="w-full text-body-medium-button"
                  >
                    <div class="label flex flex-col gap-[10px]">
                      <div class="flex items-center gap-3">
                        <v-icon icon="timer"></v-icon>
                        <div class="text-heading-4-medium">Krakoročna oddaja</div>
                      </div>
                      <small class="text-body-regular text-black-40"
                        >Nepremičnina je namenjena časovno omejeni oddaji. To so
                        lahko dan, teden ali tedni ali meseci. V tem primeru je
                        večinoma nepremičnin že opremljena. Podrobnosti navedite v
                        opisu nepremičnine.</small
                      >
                    </div>
                    <div class="icon">
                      <v-icon icon="radio-unchecked" class="unchecked"></v-icon>
                      <v-icon icon="radio-checked" class="checked"></v-icon>
                    </div>
                  </label>
                </div>
              </li>
              <li class="w-full">
                <div :class="['radio group flex items-center', (validationErrors.nutzungsart ? 'has-errors' : '')]">
                  <input
                    id="nalozba"
                    type="radio"
                    value="anlage"
                    name="nutzungsart"
                    class="hidden"
                    v-model="usageType"
                  />
                  <label for="nalozba" class="w-full text-body-medium-button">
                    <div class="label flex flex-col gap-[10px]">
                      <div class="flex items-center gap-3">
                        <v-icon icon="chart-data"></v-icon>
                        <div class="text-heading-4-medium">Naložba</div>
                      </div>
                      <small class="text-body-regular text-black-40"
                        >Nepremičnina kot naložba pomeni, da je nepremičnina že
                        oddana ali, da jo vi lahko sami oddate. Podrobnosti
                        navedite v opisu nepremičnine.</small
                      >
                    </div>
                    <div class="icon">
                      <v-icon icon="radio-unchecked" class="unchecked"></v-icon>
                      <v-icon icon="radio-checked" class="checked"></v-icon>
                    </div>
                  </label>
                </div>
              </li>
            </ul>
          </figure>
        </form>
      </figure>
    </main>
    <v-add-listing-foot>
      <a
        @click="submitForm('select-usage-type')"
        :class="['button button--md h-[48px] w-[240px] px-6', (validated ? '' : 'button button--gray')]"
      >
        <label class="text-small-text-medium">Nadaljujte</label>
        <v-icon icon="arrow-right" size="4"></v-icon>
      </a>
    </v-add-listing-foot>
  </section>
</template>
<script>
import AddListingFootVue from '../AddListingFoot.vue';
import AddListingHeadVue from '../AddListingHead.vue';

export default {
  components: {
    "v-add-listing-foot": AddListingFootVue,
    "v-add-listing-head": AddListingHeadVue,
  },
  props: {
    old: {
      type: Object,
      required: false,
      default: {},
    },
    routes: {
      type: Object,
      required: true,
    },
    validationErrors: {
      type: Object,
      required: true,
      default: {},
    },
    stepData: {
      type: Object,
      required: true,
      default: {},
    },
  },
  data() {
    return {
      usageType: null,
    };
  },
  mounted() {
    this.usageType = this.stepData.nutzungsart
  },
  methods: {
    submitForm(formId) {
      if(this.validated) document.getElementById(formId).submit();
    },
  },
  computed: {
    validated() {
        if(!this.usageType) return false

        return true;
    }
  },
};
</script>
